module.exports = __webpack_public_path__ + "img/hr-wooden-particle-06.84169d22.png";